import { Component } from 'react';
import { ErrorPage } from '@pages';

interface Props {
  children: React.ReactNode;
}

interface State {
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  // componentDidCatch(error: Error, info: ErrorInfo) {
  //   console.log(error, info.componentStack);
  // }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return <ErrorPage error={error} />;
    }

    return children;
  }
}
